import React from 'react';
import { copyFor } from '../../../chargerUx/copy';
import { formatSessionTime } from '../../../utils/formatDate';
import './SessionTimeline.less';

/**
 * SessionTimeline — the simplified "what happened" list on session detail.
 *
 * Entries come from the API already written for a client (a title and an
 * optional one-line reason); internal and protocol events are not in the
 * list at all. Times are when each thing happened at the charger.
 */
function SessionTimeline({ entries = [], locale }) {
  const list = Array.isArray(entries) ? entries.filter((e) => e && typeof e.title === 'string') : [];
  if (!list.length) return null;
  const c = copyFor(locale);
  return (
    <section className="gc-session-timeline" aria-label={c.timeline} data-testid="session-timeline">
      <h3 className="gc-session-timeline__heading">{c.timeline}</h3>
      <ol className="gc-session-timeline__list">
        {list.map((entry, i) => (
          <li key={entry.eventId || `${entry.eventType}-${i}`} className="gc-session-timeline__item">
            <time className="gc-session-timeline__time" dateTime={entry.occurredAt || undefined}>
              {entry.occurredAt ? formatSessionTime(entry.occurredAt) : ''}
            </time>
            <div className="gc-session-timeline__text">
              <span className="gc-session-timeline__title">{entry.title}</span>
              {typeof entry.detail === 'string' && entry.detail && (
                <span className="gc-session-timeline__detail">{entry.detail}</span>
              )}
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default SessionTimeline;
